import type { ReactNode } from 'react';

import Box from '@mui/material/Box';

import { Logo } from '@src/components/icons';

const StyleSheet = {
  root: {
    display: 'block',
    maxWidth: '360px',
    margin: '0 auto',
  },
  content: {
    flexDirection: 'column',
    justifyContent: 'start',
    display: 'flex',
    width: '100%',
    maxWidth: '360px',
    padding: '16px',
    alignItems: 'center',
    transform: 'translateY(-10vh)',
  },
  logo: {
    width: '250px',
    height: '320px',
    '& svg': { width: '100%', height: '100%' },
  },
};

interface AuthLayoutProps {
  children?: ReactNode;
}

function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <Box sx={StyleSheet.root}>
      <Box sx={StyleSheet.content}>
        <Box sx={StyleSheet.logo}>
          <Logo />
        </Box>
        {children}
      </Box>
    </Box>
  );
}

AuthLayout.displayName = 'AuthWrapper';
export default AuthLayout;
